import React from 'react';
export function StorySection() {
  return <section id="experience" className="py-28 md:py-36 px-0 fade-section" data-id="element-131">
      <div className="grid grid-cols-1 md:grid-cols-5 min-h-[600px]" data-id="element-132">
        {/* Image Side (60%) */}
        <div className="md:col-span-3 h-[500px] md:h-auto relative" data-id="element-133">
          <img src="https://images.unsplash.com/photo-1566417713940-fe7c737a9ef2?w=1200&q=80" alt="Tempoo Lounge Atmosphere" className="w-full h-full object-cover" style={{
          filter: 'grayscale(100%) contrast(1.1)'
        }} data-id="element-134" />
        </div>

        {/* Text Side (40%) */}
        <div className="md:col-span-2 bg-gold p-12 md:p-16 lg:p-24 flex flex-col justify-center" data-id="element-135">
          <span className="font-sans text-sm tracking-mega-wide text-black/60 uppercase mb-2" data-id="element-136">
            Our
          </span>
          <h2 className="font-serif text-[32px] md:text-[38px] lg:text-[50px] text-black mb-8" data-id="element-137">
            PHILOSOPHY
          </h2>

          <p className="font-sans text-lg text-black/80 leading-relaxed mb-12" data-id="element-138">
            Tempoo was born from a desire to bring authentic West African
            flavors to the DMV area, bridging the gap between rich culinary
            heritage and the vibrant energy of late-night lounge culture.
            <br data-id="element-139" />
            <br data-id="element-140" />
            We celebrate traditional recipes—from perfectly spiced Suya to smoky
            Jollof—while offering an upscale, seamless transition from dining to
            nightlife. As the evening progresses, the lights dim, the tempo
            rises, and our space transforms, offering an uninterrupted journey
            of taste, sound, and atmosphere.
          </p>

          <div className="w-full h-px bg-black/20 mb-8" data-id="element-141" />

          <span className="font-sans text-sm tracking-ultra-wide text-black/50 uppercase" data-id="element-142">
            Est. 2024
          </span>
        </div>
      </div>
    </section>;
}